
import axios from 'axios';

import { store , defineListControllers  } from "../state/redux";

export const  axios_memory_gethorodatagebyid= async(id_lead)=>{
    const controller = new AbortController();
    const actucontrollers = store.getState().formules.listcontrollers ;
    store.dispatch(defineListControllers([...actucontrollers,controller]))  ;
    return await axios.post(`/memory/gethorodatagebyid/`,{id_lead},{signal: controller.signal});
}

export const  axios_memory_writehorodatage= async(horo)=>{
    return await axios.post(`/memory/writehorodatage/`,horo,{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}}) ;
}

export const  axios_memory_getnotebyid= async(id_lead)=>{
    return await axios.post(`/memory/getnotebyid/`,{'id':id_lead});
}

export const  axios_memory_writenote = async({id,note})=>{
    return await axios.post(`/memory/writenote/`,{id,note},{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}}) ;
}

export const  axios_memory_memoclick= (data)=>{
    return  axios.post(`/memory/memoclick/`,data,{headers: { 'Accept': 'application/json', 'Content-Type': 'application/json'}}) ;
}


